import { IPaginatedData } from "shared/models/common";

export enum AlertType {
  Suggestion = "Suggestion",
  Nudge = "Nudge",
}

export type ClientAlertID = string;

export interface IClientAlertData {
  id: string;
  performer: {
    forename: string;
    surname: string;
  };
  breakdown: {
    id: string;
    name: string;
    closingDate: Date;
    closedEarly?: boolean;
    closedReason?: string;
  };
  role: {
    name: string;
  };
  read: boolean;
  dateCreated: Date;
  alertType: AlertType;
}

export interface IClientAlert extends IClientAlertData {
  id: ClientAlertID;
}

export interface IPaginatedClientAlertList
  extends IPaginatedData<IClientAlert> {}

export interface IClientAlertListResponse {
  items: IClientAlertData[];
  total: number;
  unreadTotal: number;
  _links: {};
}

export interface IInteractionObject {
  id: string;
  alertType: AlertType;
  read: boolean;
}
